import { memo } from 'react';
import { X } from 'lucide-react';

// ─── Zeit-Schieberegler ──────────────────────────────────────────────────────
//
// Blendet über der Baum-Ansicht einen Jahres-Regler ein: im gewählten Jahr
// werden Verstorbene ausgegraut und noch nicht Geborene ausgeblendet.

interface TimeSliderProps {
  year: number;
  min: number;
  max: number;
  onChange: (year: number) => void;
  onClose: () => void;
}

export const TimeSlider = memo(function TimeSlider({ year, min, max, onChange, onClose }: TimeSliderProps) {
  return (
    <div className="pointer-events-auto absolute left-1/2 top-4 z-10 w-[min(28rem,calc(100vw-2rem))] -translate-x-1/2 rounded-xl border border-slate-200 bg-white/95 p-3 shadow-lg backdrop-blur">
      <div className="mb-1.5 flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">Zeitreise</span>
        <div className="flex items-center gap-2">
          <span className="tabular-nums text-lg font-bold text-blue-600">{year}</span>
          <button
            onClick={onClose}
            className="rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
            aria-label="Zeitreise beenden"
            title="Zeitreise beenden"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={1}
        value={year}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
        className="h-2 w-full cursor-pointer appearance-none rounded-full bg-slate-200 accent-blue-600"
        aria-label="Jahr auswählen"
      />
      <div className="mt-1 flex justify-between text-[10px] tabular-nums text-slate-400">
        <span>{min}</span>
        <span>{max}</span>
      </div>
      <p className="mt-1.5 text-[11px] leading-snug text-slate-400">
        Verstorbene werden ausgegraut, noch nicht Geborene ausgeblendet. Personen ohne Datum bleiben sichtbar.
      </p>
    </div>
  );
});
